var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-select-tag-head" },
    [
      _c("tag", { attrs: { title: _vm.title } }),
      _c(
        "button",
        {
          staticClass: "custom-select-tag-head__button-reset",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.$emit("clear")
            }
          }
        },
        [
          _c("f-sprite-icon", {
            attrs: {
              slot: "icon",
              "icon-link": _vm.$options.icons.IconCloseFat.id
            },
            slot: "icon"
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }